import {Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MdCluGhostModeFnRxDbCashDeskComponent } from './@modals/md-clu-ghostmode-fn-rxdb-cashdesk/md-clu-ghostmode-fn-rxdb-cashdesk.component';
import { MdCluGhostModeFnAgentTicketsComponent } from './@modals/md-clu-ghostmode-fn-agent-tickets/md-clu-ghostmode-fn-agent-tickets.component';
import { MdCluGhostModeFnZTicketVaultDocumentsComponent } from './@modals/md-clu-ghostmode-fn-zticketvault-documents/md-clu-ghostmode-fn-zticketvault-documents.component';

@Component({
    selector: 'clu-ghostmode-fns-dialog',
    templateUrl: './clu-ghostmode-fns-dialog.component.html',
    styleUrls: ['./clu-ghostmode-fns-dialog.component.scss'],
})
export class CluGhostModeFnsDialogComponent implements OnInit {

    constructor(
        private matDialogRef: MatDialogRef<CluGhostModeFnsDialogComponent>,
        private _matDialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) private data: { randomize?: boolean, length?: number }
    ){
    }

    ngOnInit(): void {
    }

    
    doOpenMdCluGhostModeFnRxDbCashDeskModalAction_CashDesk(){
        this._matDialog.open(MdCluGhostModeFnRxDbCashDeskComponent, {autoFocus: false, disableClose: true, width: '100%', maxWidth: '100%', minHeight: '100%', maxHeight: '100%', height : '100%', data : { } })
            .afterClosed()
            .subscribe((res : any) => {
                if(res){ 
                }
            });
    }

    doOpenMdCluGhostModeFnAgentTicketsModalAction_CashDesk() {
        this._matDialog.open(MdCluGhostModeFnAgentTicketsComponent, {autoFocus: false, disableClose: true, width: '100%', maxWidth: '100%', minHeight: '100%', maxHeight: '100%', height : '100%', data : { } });
    }

    doOpenMdCluGhostModeFnZTicketVaultDocumentsModalAction_CashDesk() {
        this._matDialog.open(MdCluGhostModeFnZTicketVaultDocumentsComponent, {autoFocus: false, disableClose: true, width: '100%', maxWidth: '100%', minHeight: '100%', maxHeight: '100%', height : '100%', data : { } });
    }


    onClose(_closeGhostMode : boolean = false) {
        this.matDialogRef.close(_closeGhostMode);
    }

}